import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';
import { ApiGetRequest } from './api';
import GlobalMenu from '../router/menu';
Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  state: {
    branch: [
      {
        label: 'DKM SURABAYA',
        domain: 'https://sby.mydeposys.com/api',
      },
      {
        label: 'DKM JAKARTA',
        domain: 'https://jkt.mydeposys.com/api',
      },
      {
        label: 'DKM SEMARANG',
        domain: 'https://smg.mydeposys.com/api',
      },
      {
        label: 'DKM CAKUNG',
        domain: 'https://ckg.mydeposys.com/api',
      },
      {
        label: 'DKM BELAWAN',
        domain: 'https://blw.mydeposys.com/api',
      },
      {
        label: 'JAVA SEMARANG',
        domain: 'https://jsmssmg.mydeposys.com/api',
      },
      {
        label: 'JAVA LAMPUNG',
        domain: 'https://jsmslpg.mydeposys.com/api',
      },
    ],
    document_type: ['Export', 'Import', 'Repo', 'Free Use'],
    default_type: ['GP', 'HC', 'OT', 'RF', 'FR'],
    default_size: [20, 21, 40, 41, 45],
    default_condition: ['AV', 'DM', 'AV-NA', 'DM-NA'],
    default_cleaning: ['WW', 'WD', 'WC'],
    default_currency: ['IDR', 'USD', 'SGD', 'HKD'],
    currency_company: {
      JAKARTA: 'USD',
    },
    upload_foto: 15,
    upload_foto_damage: 8,
    upload_foto_crani: 8,
    penyusutan: [
      { value: 'garis_lurus', label: 'Garis Lurus' },
      { value: 'jumlah_angka_tahun', label: 'Jumlah Angka Tahun' },
      { value: 'saldo_menurun', label: 'Saldo Menurun' },
    ],
    // principle price = 1 // ditampilkan di menu harga principle
    // as other cost = 1 // form yang ditampilkan persis dengan form other cost
    type_payment: [
      {
        name: 'document',
        label: 'Document Fee',
        type: ['cash', 'credit'],
        principle_price: 1,
        as_other_cost: 0,
      },
      {
        name: 'lift_off',
        label: 'Lift Off',
        type: ['cash', 'credit'],
        principle_price: 1,
        as_other_cost: 0,
      },
      {
        name: 'lift_on',
        label: 'Lift On',
        type: ['cash', 'credit'],
        principle_price: 1,
        as_other_cost: 0,
      },
      {
        name: 'cleaning',
        label: 'Cleaning',
        type: ['cash', 'credit'],
        principle_price: 1,
        as_other_cost: 0,
      },
      {
        name: 'seal',
        label: 'Seal',
        type: ['cash', 'credit'],
        principle_price: 1,
        as_other_cost: 0,
      },
      {
        name: 'cancelation',
        label: 'Cancelation',
        type: ['cash', 'credit'],
        principle_price: 1,
        as_other_cost: 0,
      },
      {
        name: 'otherfee',
        label: 'Other Fee (Photo/Survey/Shifting)',
        type: ['cash', 'credit'],
        principle_price: 1,
        as_other_cost: 1,
      },
      {
        name: 'export_release_surcharge',
        label: 'Export Release Surcharge',
        type: ['cash', 'credit'],
        principle_price: 1,
        as_other_cost: 1,
      },
      {
        name: 'fuel_surcharge',
        label: 'Fuel Surcharge',
        type: ['cash', 'credit'],
        principle_price: 1,
        as_other_cost: 1,
      },
      {
        name: 'pay_seal',
        label: 'Extra Seal',
        type: ['cash'],
        principle_price: 0,
        as_other_cost: 0,
      },
      {
        name: 'pay_repair',
        label: 'Direct Cost Repair',
        type: ['cash'],
        principle_price: 0,
        as_other_cost: 0,
      },
      {
        name: 'storage',
        label: 'Storage',
        type: ['credit'],
        principle_price: 1,
        as_other_cost: 0,
      },
      {
        name: 'truck_interchange',
        label: 'Truck Interchange',
        type: ['credit'],
        principle_price: 0,
        as_other_cost: 0,
      },
      {
        name: 'truck_booking',
        label: 'Truck Booking',
        type: ['credit'],
        principle_price: 0,
        as_other_cost: 0,
      },
      {
        name: 'eor',
        label: 'EOR',
        type: ['credit'],
        principle_price: 0,
        as_other_cost: 0,
      },
      {
        name: 'pti',
        label: 'PTI',
        type: ['credit'],
        principle_price: 0,
        as_other_cost: 0,
      },
    ],
    access_token: '',
    expred_time: '',
    expired_in: '',
    user: {},
  },
  getters: {
    user(state) {
      return state.user;
    },
  },
  mutations: {
    changeUser(state, data) {
      state.user = Object.assign({}, state.user, data);
    },
  },
  actions: {
    async getUserInfo({ commit }) {
      let result = await ApiGetRequest('auth/user-info');
      if (!result.error) {
        let default_route = '';
        let loggeduser = result.data.object;
        let user_permission = loggeduser ? loggeduser.user_permission : [];

        // get default menu
        for (let index = 0; index < user_permission.length; index++) {
          if (
            parseInt(user_permission[index].view) === 1 &&
            default_route === ''
          ) {
            let menu_user =
              user_permission[index].modul === 'operasional'
                ? GlobalMenu.menuOperational
                : user_permission[index].modul === 'finance'
                ? GlobalMenu.menuFinance
                : user_permission[index].modul === 'setting'
                ? GlobalMenu.menuSetting
                : GlobalMenu.menuLogistic;

            let check_menu = [];
            for (let indexF = 0; indexF < menu_user.length; indexF++) {
              if (
                menu_user[indexF].subItems &&
                menu_user[indexF].subItems.length
              ) {
                for (
                  let indexS = 0;
                  indexS < menu_user[indexF].subItems.length;
                  indexS++
                ) {
                  if (
                    menu_user[indexF].subItems[indexS].name ===
                    user_permission[index].name
                  ) {
                    check_menu.push(menu_user[indexF].subItems[indexS]);
                    break;
                  }
                }
              } else if (
                menu_user[indexF].name === user_permission[index].name
              ) {
                check_menu.push(menu_user[indexF]);
                break;
              }
            }

            if (check_menu && check_menu.length) {
              loggeduser.default_route = check_menu[0].link;
              break;
            }
          }
        }

        commit('changeUser', loggeduser);
        return loggeduser;
      } else {
        return null;
      }
    },
  },
  // strict: process.env.NODE_ENV !== 'production',
});

export default store;
